import type { QueryClient } from "@tanstack/react-query";

export type InvoiceChangeInvalidationArgs = {
  invoiceUid: string;
  jobEventUids?: string[];
  /** When set (e.g. deposit invoice), refreshes the per-quote deposit-invoices list. */
  quoteId?: number | null;
};

/**
 * Keeps invoice UIs, job-event rows, quote lists, and deposit-invoice modals aligned after any
 * invoice mutation or realtime payment/update (verify button, socket, notification).
 */
export function invalidateAfterInvoiceChange(queryClient: QueryClient, args: InvoiceChangeInvalidationArgs): void {
  const { invoiceUid, jobEventUids = [], quoteId } = args;

  queryClient.invalidateQueries({ queryKey: ["invoice", invoiceUid] });
  queryClient.invalidateQueries({ queryKey: ["invoices"] });
  queryClient.invalidateQueries({ queryKey: ["quotes"] });

  if (quoteId != null && Number.isFinite(Number(quoteId))) {
    const qid = Number(quoteId);
    queryClient.invalidateQueries({ queryKey: ["quotes", qid, "deposit-invoices"] });
  }

  for (const uid of jobEventUids) {
    if (!uid) continue;
    queryClient.invalidateQueries({ queryKey: ["invoices", "by-job-event", uid] });
    queryClient.invalidateQueries({ queryKey: ["invoice", uid] });
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("flownect:quotes-updated", { detail: { invoiceUid, quoteId } }));
  }
}
